<script setup>
  import { computed, inject } from 'vue'
  import CountryFlag from '@/components/CountryFlag.vue'

  const tournament = inject('tournament')
  const allEntries = inject('allEntries')

  const props = defineProps(['entryId'])

  const showFlags = computed(() => {
    const tournamentSettings = tournament.value.settings || {}
    return tournamentSettings.showFlags === false ? false : true
  })
</script>


<template>
  <span v-if="showFlags" class="me-2">
    <CountryFlag :country="allEntries[entryId]?.country" />
  </span>
  {{ allEntries[entryId]?.name || $t('entry.unknown') }}
</template>